export default __webpack_public_path__ + "062641573ecf4df3e717b75c72b56c63.svg";